import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-10 h-10 text-gray-600" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Payment Cancelled</h2>
          <p className="text-gray-600 mb-6">
            Your payment was cancelled. No charges were made to your account.
          </p>
          <p className="text-sm text-gray-500 mb-6">
            Changed your mind? The Dealership Killer eBook is still available for purchase.
          </p>
          <Button
            onClick={() => navigate('/')}
            className="w-full bg-orange-600 hover:bg-orange-700"
          >
            Return to Home
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;